import { useEffect, useRef } from 'react';

export function useAutosave<T>(data: T, save: (data: T) => void, delayMs = 500): void {
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    const t = setTimeout(() => save(data), delayMs);
    return () => clearTimeout(t);
  }, [data, save, delayMs]);
}
